import { MediaCollection } from '@arpeggi/shared'
import axios from 'axios'

export const getOneMediaCollection = async (id: number) => {
  const { data } = await axios.get<MediaCollection>(`/api/v2/media-collection/${id}`)
  return data
}
